import { actionStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsActions";
import { headerStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsHeader";
import { css } from "styled-components";

actionStyles.printButton = {
    mergeCss: true,
    css: css`
        padding: 0 10px;
        margin-right: 10px;
        white-space: nowrap;
    `,
    variant: "secondary",
};

actionStyles.scheduleButton = {
    mergeCss: true,
    css: css`
        padding: 0 10px;
        margin-right: 10px;
        white-space: nowrap;
    `,
    variant: "secondary",
};

actionStyles.editButton = {
    mergeCss: true,
    css: css`
        padding: 0 10px;
        margin-right: 10px;
        white-space: nowrap;
    `,
    variant: "secondary",
};

actionStyles.shareButton = {
    mergeCss: true,
    css: css`
        padding: 0 10px;
        margin-right: 10px;
        white-space: nowrap;
    `,
    variant: "secondary",
};

actionStyles.addItemButton = {
    mergeCss: true,
    typographyProps: {
        weight: "bold",
        css: css`
            white-space: nowrap;
        `,
    },
    css: css`
        padding: 0 10px;
        margin-right: 10px;
        white-space: nowrap;
    `,
    variant: "secondary",
};

actionStyles.removeSelectedButton = {
    mergeCss: true,
    typographyProps: {
        weight: "bold",
        css: css`
            white-space: nowrap;
        `,
    },
    css: css`
        padding: 0 10px;
        margin-right: 10px;
        white-space: nowrap;
    `,
    variant: "primary",
};

actionStyles.addListButton = {
    mergeCss: true,
    typographyProps: {
        weight: "bold",
        css: css`
            white-space: nowrap;
        `,
    },
    css: css`
        padding: 0 10px;
        margin-right: 10px;
        min-width: 90px;
        white-space: nowrap;
    `,
};

actionStyles.overflowMenu = {
    cssOverrides: {
        wrapper: css`
            span {
                color: #ffffff !important;
            }
            ul {
                background: #ffffff !important;
            }
        `,
    },
};

actionStyles.wideHidden = {
    below: "lg",
    css: css`
        display: flex;
        flex-wrap: nowrap;
        nav {
            margin-right: 10px;
        }
    `,
};

headerStyles.sharingStatus = {
    statusText: {
        css: css`
            padding-left: 30px;
        `,
    },
    privateTooltip: {
        cssOverrides: {
            tooltipBody: css`
                color: #ffffff !important;
            `,
            tooltipContainer: css`
                margin-left: -200px !important;
                &::after {
                    left: 72% !important;
                    margin-left: 32px !important;
                }
            `,
        },
    },
};
